<template>
    <div class="proPage" v-bind:class="{'proPage--oneAction': generalStatus === null && !userIsPro}">
        <template v-if="generalStatus === null && !userIsPro && !prePaymentPopup.visible">
            <ProfileSubscriptionSlider />
            <div class="box">
                <div class="plans" v-if="!paymentBlocked">
                    <div class="proPageSpinner" v-if="paypalCapturing || !paymentPackages.length">
                        <i class="fa fa-spinner fa-pulse"></i>
                    </div>
                    <div class="plan"
                         @click="choosePlan(id)"
                        :class="{'withAdditionalInfo': paymentPackage.subtitle !== '', 'active':active_plan === id}"
                        :key="id"
                        v-for="(paymentPackage, id) in paymentPackages">
                        <div class="title">
                          {{ paymentPackage.months }} <span>{{ trans('payment.' + paymentPackage.translate) }}</span>
                        </div>
                        <div class="price">{{ paymentPackage.price }}<span v-if="paymentPackage.subtitle !== ''">{{ paymentPackage.subtitle }} {{ trans('payment.month') }}</span></div>
                    </div>
                </div>
                <div class="proPaymentPending" v-if="isApp">
                    {{ trans('payment.coming_soon') }}
                </div>
                <div class="proPaymentPending" v-if="paymentBlocked">
                    {{ trans('payment_blocked') }}
                </div>

                <button id="to-status" @click="showPrePaymentPopup()" class="btn btn-primary">{{ trans('upgrade_now') }}</button>

                <div class="promocode" v-if="!paymentBlocked">
                    <input class="promo-field" type="text" name="promocode"
                        v-model="promocodePopup.code"
                        :placeholder="trans('payment.your_promotion_code')">
                    <button class="btn" @click="submitPromoCode">{{ trans('ok') }}</button>
                </div>
                <span v-if="promocodePopup.error">{{ promocodePopup.error }}</span>
                <div v-if="false" class="proPageTerms" v-html="trans('pro_upgrade_message')"></div>
            </div>
        </template>

        <template v-else-if="generalStatus === null && userIsPro">
            <div class="status check" v-if="isDesktop">
              <div class="logo-tagline">
                <div class="logo">
                  <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                </div>
              </div>
              <div class="box">
                <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
              </div>
              <div class="box">
                <div class="note">
                  <div class="top">
                    <span>{{ trans('payment.active_until') }}</span>
                  </div>
                  <div class="bottom">
                    <div class="title">{{ proExpireDate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="secondary-menu status check" v-if="isMobile">
                <div class="secondary-menu-body">
                    <div class="logo-tagline" style="opacity: 0">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top">
                                <span>{{ trans('payment.active_until') }}</span>
                            </div>
                            <div class="bottom">
                                <div class="title">{{ proExpireDate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          <div  v-if="paypal_settings.subscription_status && paypal_settings.subscription_status !== 'CANCELLED'" class="cancel-subscription">
            <span @click="cancelPaypalSubscription">{{trans('cancel_subscription')}}</span>
          </div>
        </template>

        <template v-else-if="generalStatus === 'success'">
            <div class="secondary-menu status success">
                <div class="secondary-menu-body">
                    <div :style="{opacity:+ isDesktop}" class="logo-tagline">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top"></div>
                            <div class="bottom">
                                <div class="title">{{ userIsPro ? trans('successful_pro_upgrade') : trans('we_hope_you_enjoyed_pro') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="generalStatus === 'error'">
            <div class="secondary-menu status error">
                <div class="secondary-menu-body">
                    <div class="logo-tagline">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/images/splash/avatar_sorry.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top"></div>
                            <div class="bottom">
                                <div class="title failed">{{ trans('failed_pro_upgrade') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

      <PaymentModal @hideModal="hidePrePaymentPopup" v-if="prePaymentPopup.visible">
        <div class="package-payment">
          <div class="title">
            {{ prePaymentPopup.title }}
          </div>
          <div class="description">
          </div>
          <div class="package-payment-box">
            <a class="btn btn-primary btn-long"
               v-if="issuers['flexpay']"
               @click.prevent="initiatePayment('flexpay')"
            >{{ trans('payment.credit_card') }}</a>
            <div class="package-payment-box-icons">
              <img src="/images/pro/icons/visa-icon.svg" @click.prevent="initiatePayment('flexpay')" />
              <img src="/images/pro/icons/MC-icon.svg" @click.prevent="initiatePayment('flexpay')" />
            </div>
            <div class="text-mute">{{ prePaymentPopup.recurring ? trans('payment.renews_automatically_until_cancelled') : '' }}</div>
          </div>

          <div
              v-if="issuers['2000charge'] || issuers['sofort'] || issuers['paypal']"
              class="proConfirmAlertButtonsAlt"
          >{{ trans('payment.alternative_payments') }}:</div>

          <div class="package-payment-box" v-if="issuers['2000charge'] || issuers['sofort'] || issuers['paypal']">
            <i
                v-if="issuers['2000charge'] && issuers['paypal'] && twokchargeIframeLoaded"
                class="fa fa-spinner fa-pulse"
            ></i>
            <div class="package-payment-box-item">
              <div
                @click="createPaypalOrder"
                class="package-payment-box-item-paypal"
              >
                <!--IF YOU WANT TO USE SUBSCRIPTIONS OR INVOICE @click="showPaypalPopup"-->
                <img src="/images/pro/icons/PayPal-icon.svg" />
                <img v-if="createOrderRequest" class="preloader" src="/assets/img/preloader.svg" alt="">
              </div>
              <div
                  v-if="issuers['segpay'] && (issuers['2000charge'] || issuers['sofort'])"
                  @click.prevent="initiatePayment('segpay')"
              >
                <img src="/images/pro/icons/segpay-icon.svg" /> <br/>
                <span class="text-mute">({{ trans('payment.credit_card') }})</span>
                <p style="font-size: 12px;" class="text-mute">Please visit <a href="https://vtsup.com">SEGPAYEU.COM</a>, <br /> our authorized payment processor.</p>
              </div>
              <div
                  v-if="issuers['2000charge'] && twokchargeIframeLoaded && (issuers['2000charge'] || issuers['sofort'])"
                  @click="showTwokchargePopup(packageId)"
              >
                <img src="/images/pro/icons/sofort-icon.svg" />
              </div>
            </div>
            <div class="package-payment-box-item">
              <div
                  v-if="issuers['2000charge'] && twokchargeIframeLoaded && (issuers['2000charge'] || issuers['sofort'])"
                  @click="showTwokchargePopup(packageId)"
              >
                <img src="/images/pro/icons/giropay-icon.svg" />
              </div>
              <div
                  v-if="issuers['2000charge'] && twokchargeIframeLoaded && (issuers['2000charge'] || issuers['sofort'])"
                  @click="showTwokchargePopup(packageId)"
              >
                <img src="/images/pro/icons/paysafe-icon.svg" />
              </div>
            </div>

            <div class="package-payment-box-item">
              <!--
              Here must be segpay if 2kc works
              -->
              <div
                  style="width:120px;"
                  v-if="issuers['segpay'] && (issuers['2000charge'] || issuers['sofort'])"
                  @click.prevent="initiatePayment('segpay')"
              >
              </div>
            </div>
          </div>
        </div>

      </PaymentModal>
      <PaymentModal @hideModal="hidePaypalWidget" v-if="paypalPopup.visible">
        <div class="package-payment paypal">
          <div class="title">
            {{ paypalPopup.title }}
          </div>
          <div class="subscription-card">
            <h3>Subscription Plan</h3>
            <div id="paypal-button-container"></div>
          </div>
          <!--
          <div :style="{opacity:+ !paypalPopup.success}" class="description">
            <b v-if="currentLang === 'en'">{{paymentPackages[active_plan].price}} {{trans('payment.one_time')}}</b>
            <b v-else>{{trans('payment.one_time')}} {{paymentPackages[active_plan].price}}</b><br />
            <span>{{trans('payment.no_need_to_cancel')}}</span>
          </div>
          <div class="title-bottom" v-html="paypalPopup.message"></div>
          <form data-vv-scope="paypal-form" @submit.prevent="submitPaypal" class="paypal-form" v-show="!paypalPopup.success" >
            <label>
              <input type="email" name="email" v-model="paypalPopup.email" class="form-control" :placeholder="trans('email')" :class="{'is-invalid-input': errors.has('paypal-form.email')}" v-validate="'required|email'">
              <span class="form-error" v-show="errors.has('paypal-form.email')" :class="{'is-visible': errors.has('paypal-form.email')}">
                    {{ errors.first('paypal-form.email') }}
                  </span>
            </label>
            <button type="submit" id="submit-paypal" class="btn btn-primary btn-long">{{ trans('payment.send') }}</button>
          </form>
          <button id="check-paypal-status" @click="checkPaypalPaymentStatus" v-show="paypalPopup.success"  type="button" class="btn btn-primary btn-long success-button">{{trans("payment.check_paypal_payment")}}</button>
          <span v-if="paypal_status_didnt_find">Payment doesn't processed yet. Try one more in 5 seconds please.</span>
          <button @click="goTo('/discover')" v-show="paypalPopup.success"  type="button" class="btn btn-primary btn-long success-button">{{trans("payment.return_to_buddy")}}</button>
           -->
        </div>

      </PaymentModal>

    </div>
</template>

<script>
    import _ from 'lodash'
    import { loadScript } from "@paypal/paypal-js";
    import {mapActions, mapMutations, mapState} from 'vuex'
    import ProfileSubscriptionSlider from '@profile/views/widgets/subscription/ProfileSubscriptionSlider.vue';
    import Alert from '@buddy/views/widgets/Alert.vue'
    import PaymentModal from '@buddy/views/widgets/PaymentModal.vue'

    export default {
        props: ['bottomMenuState'],
        mixins: [
            require('@general/lib/mixin').default,
        ],
        data() {
            return {
                paypalCapturing: false,
                createOrderRequest:false,
                generalStatus: null,
                paypal_status_didnt_find: null,
                paymentBlocked: false,
                paypal_settings: {},
                issuer: null,
                active_plan:1,
                issuerCredentials: null,
                packageId: 0,

                paymentPackages: [],
                issuers: {},

                twokchargeIframeLoaded: false,
                twokchargeIframe: null,

                prePaymentPopup: {
                    visible: false,
                    recurring: false,
                    message: '',
                    title: '',
                },
                sofortPopup: {
                    visible: false,
                    countries: [],
                    country: 'DE',
                    first_name: '',
                    last_name: '',
                    email: '',
                },
                paypalPopup: {
                    visible: false,
                    email: '',
                    title: '',
                    message: '',
                    success: false
                },
                promocodePopup: {
                    code: '',
                    error: '',
                },
            }
        },
        components: {
            PaymentModal,
            ProfileSubscriptionSlider,
            Alert,
        },
        computed: {
            ...mapState({
                userIsPro: 'userIsPro',
                profile: 'profile',
            }),
            currentLang(){
              return app.lang
            },
            proExpireDate() {
                return moment(this.profile.pro_expires_at).format('D MMMM YYYY')
            },
            origin() {
                return `https://${window.APP_DOMAIN}`;
            },
        },
        methods: {
            ...mapMutations([
                'setUserIsPro',
                'setDiscreetMode',
                'updateUser'
            ]),
            ...mapActions([
                'loadCurrentUserInfo',
            ]),
            cancelPaypalSubscription(){
              let self = this;
              this.$store.dispatch('showDialog', {
                mode: 'confirm',
                message: self.trans('confirm_cancel'),
                callback: () => {
                  axios.post('/api/subscription/paypal/cancel', {})
                      .then((response) => {
                        if (response.data.status === 'error') {
                          self.showErrorNotification(self.trans('cancel_failed'))
                        }else{
                          self.showSuccessNotification(self.trans('subscription_canceled'))
                          self.paypal_settings.subscription_status = 'CANCELLED';
                        }
                      })
                      .catch((response) => {
                        self.showErrorNotification(self.trans('cancel_failed'))
                      })
                }
              })
            },
            checkPaypalPaymentStatus(){
              let self = this;
              self.paypal_status_didnt_find = null;
              let callback = async function(){
                await axios.post('/api/subscription/paypal/check-status')
                    .then((response) => {
                      if (response.data.status) {
                        self.setUserIsPro(true)
                        self.loadCurrentUserInfo(true)
                        self.$emit('bottomMenuState', true)
                        self.setStatus('success')
                        self.hidePaypalWidget();
                        self.hidePrePaymentPopup();
                      }else{
                        self.paypal_status_didnt_find = true;
                      }
                    })
                    .catch((response) => {
                      return false;
                    })
              }
              this.runLoadingFunction('#check-paypal-status', callback);

            },
            choosePlan(id){
                this.active_plan = id;
            },
            setStatus(status) {
                this.generalStatus = status
                if (status === 'error') {
                    this.$emit('bottomMenuState', true)
                }
            },
            hideSofortWidget() {
                this.sofortPopup.visible = false
            },
            hidePaypalWidget() {
                this.paypalPopup.visible = false
                this.paypalPopup.success = false;
            },
            submitPaypal() {
                let callback = () => {
                  return this.$validator.validateAll('paypal-form').then((result) => {
                      if (result) {
                        let sendData = {
                            paypalEmail: this.paypalPopup.email,
                            duration: this.packageId
                        }

                        return axios.post('/api/subscription/paypal', sendData)
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    //this.paypalPopup.visible = false;
                                    this.paypalPopup.title = this.trans('payment.thank_you');
                                    this.paypalPopup.message = this.trans('payment.paypal.successMessage', {link: response.data.link})
                                    this.paypalPopup.success = true;

                                    return true;
                                }
                            })
                            .catch((response) => {
                                return false;
                            })
                      }
                  })
                }

                this.runLoadingFunction('#submit-paypal', callback);
            },
            scrollToTop(){
              var myDiv = document.getElementById('application-wrapper');
              myDiv.scrollTop = 0;
            },
            showPrePaymentPopup() {
                let paymentPackage = this.paymentPackages[this.active_plan];
                this.packageId = paymentPackage.key
                this.issuers = paymentPackage.issuers

                this.prePaymentPopup.recurring = paymentPackage.recurring
                this.prePaymentPopup.title = this.trans('payment.upgrade.' + paymentPackage.translate)
                this.prePaymentPopup.message = this.trans('payment.please_select_payment_option')
                this.prePaymentPopup.visible = true
                this.scrollToTop();

                this.$emit('prePaymentShowed', true)
            },
            showTwokchargePopup(packageId) {
                let price_package = _.find(this.paymentPackages, { key: packageId });

                let amount = 'additional_price' in price_package && price_package.additional_price['2000charge'] ? price_package.additional_price['2000charge'] : price_package.amount;
                let data = {
                    action: 'set-form',

                    TWO_THOUSAND_CHARGE_KEY: this.issuerCredentials['2000charge'],
                    TWO_THOUSAND_CHARGE_MODE: null,
                    TWO_THOUSAND_CHARGE_FORM_OPTIONS: {
                        COMPANY_NAME: 'BUDDY PRO',
                        DESCRIPTION: this.prePaymentPopup.title,
                        EXTRA: 'Activate PRO',
                        AMOUNT: amount,
                        CURRENCY: "EUR",
                        LANGUAGE: 'US',
                    },

                    ALTERNATIVE_PAYMENTS_KEY: this.issuerCredentials['2000charge'],
                    ALTERNATIVE_PAYMENTS_MODE: null,
                    ALTERNATIVE_PAYMENTS_FORM_OPTIONS: {
                        COMPANY_NAME: 'BUDDY PRO',
                        DESCRIPTION: this.prePaymentPopup.title,
                        EXTRA: 'Activate PRO',
                        AMOUNT: amount,
                        CURRENCY: "EUR",
                        LANGUAGE: 'US',
                    },
                    themeStyle: 'dark',
                    customCss: null,
                }
                
                this.twokchargeIframe.contentWindow.postMessage(JSON.stringify(data), '*')

                data = { action: 'set-form-values' }
                this.twokchargeIframe.contentWindow.postMessage(JSON.stringify(data), '*')

                // Show twokchargeIframe
                jQuery(this.twokchargeIframe).fadeIn()
            },
            async createPaypalOrder(){
              this.createOrderRequest = true;
              let self = this;
              axios.post('/api/subscription/paypal/order',{
                duration: this.packageId
              })
                .then((response) => {
                  window.location.href = response.data.href;
                })
                .catch((response) => {
                  self.createOrderRequest = false;
                  self.showErrorNotification('payment_failed_please_contact_admin')
                })
            },
            async showPaypalPopup() {
                //this.prePaymentPopup.visible = false;
                this.paypalPopup.message = this.trans('payment.paypal.message')
                this.paypalPopup.title = this.trans('payment.upgrade_paypal.'+this.paymentPackages[this.active_plan].key)
                this.paypalPopup.visible = true;
                await this.$nextTick();
                try {
                  let paymentPackage = this.paymentPackages[this.active_plan];
                  const paypal = await loadScript({
                    "client-id": this.paypal_settings.credentials.client_id, // Replace with your Sandbox/Live ID
                    vault: true,
                    intent: "subscription"
                  });

                  if (paypal) {
                    await paypal.Buttons({
                      style: {
                        shape: 'rect',
                        color: 'gold',
                        layout: 'vertical',
                        label: 'subscribe'
                      },
                      createSubscription: (data, actions) => {
                        return actions.subscription.create({
                          plan_id: this.paypal_settings.packages[paymentPackage.key],
                          custom_id: String(auth.getUserId()) // Very important for Webhooks!
                        });
                      },
                      onApprove: async (data, actions) => {
                        console.log('Subscription:', data);
                        const details = await actions.subscription.get();
                        const nextBilling = details.billing_info.next_billing_time;
                        this.updateUser({'pro_expires_at' : nextBilling});
                        this.prePaymentPopup.visible = false
                        this.paypalPopup.visible = false;
                        this.setUserIsPro(true);
                        this.paypal_settings.subscription_status = true;
                        let response = await axios.post('/api/subscription/paypal/success',{subscriptionId: details.id})
                        if (response.status === 200) {

                        }
                      },
                      onError: (err) => {
                        console.error('PayPal Checkout Error:', err);
                      }
                    }).render("#paypal-button-container");
                  }
                } catch (error) {
                  console.error("Failed to load the PayPal JS SDK script", error);
                }

                this.scrollToTop();
            },
            showSofortPopup() {
                this.hidePrePaymentPopup()
                this.sofortPopup.visible = true
            },
            showPromocodePopup() {
                this.promocodePopup.code = ''
                this.promocodePopup.error = ''
            },

            hidePrePaymentPopup() {
                this.prePaymentPopup.visible = false
                this.$emit('prePaymentShowed', false)
            },

            async fetchSettings() {
                let response = await axios.post('/api/subscription/settings')
                if (response.status === 200) {
                    let data = response.data
                    this.paymentPackages = data.packages
                    this.paymentBlocked = data.payment_blocked
                    this.issuerCredentials = data.credentials
                    this.sofortPopup.countries = data.sofort_countries
                    this.paypal_settings = data.paypal
                }
            },
            async submitPromoCode() {
              try {
                let response = await axios.post('/api/subscription/promocode', {
                    code: this.promocodePopup.code
                })
                if (response.status === 200) {
                    let data = response.data
                    this.setUserIsPro(true)
                    this.setDiscreetMode(data.discreetMode)
                    this.loadCurrentUserInfo(true)
                    this.$emit('bottomMenuState', true)
                    this.setStatus('success')
                }
                }catch (e) {
                console.log(e)
              }
            },
            async initiatePayment(issuer) {
                console.log('[initiatePayment] Request', { issuer })
                let response = await axios.post('/api/subscription/initiate', {
                    issuer,
                    package_id: this.packageId,
                })
                console.log('[initiatePayment] Response', { response })
                if (response.status === 200) {
                    window.location.href = response.data.redirect
                } else {
                    this.setStatus('fail')
                    this.hidePrePaymentPopup()
                }
            },
            async handleSofortPayment() {
                console.log('[handleSofortPayment] Request')
                let response = await axios.post('/api/subscription/initiate', {
                    issuer: '2000charge-sofort',
                    package_id: this.packageId,
                    data: {
                        country: this.sofortPopup.country,
                        first_name: this.sofortPopup.first_name,
                        last_name: this.sofortPopup.last_name,
                        email: this.sofortPopup.email,
                    }
                })
                console.log('[handleSofortPayment] Response', { response })
                if (response.status === 200) {
                    this.paymentBlocked = true
                    this.hideSofortWidget()
                    window.location.href = response.data.redirect
                }
            },

            bindTwokchargeListener() {
                let self = this
                $(window).on("message", function (e) {
                    e.preventDefault()
                    try{

                      let widget = (typeof e.originalEvent.data == 'string' ?
                              JSON.parse(e.originalEvent.data)
                              :
                              {}
                      )

                      switch (widget.action) {
                        case 'hide-iframe': {
                          console.log('[Twok Listener] hide-iframe', { widget })
                          jQuery(self.twokchargeIframe).fadeOut()
                          break;
                        }
                        case 'submit-payment': {
                          console.log('[Twok Listener] Request submit-payment', { widget })
                          axios.post('/api/subscription/initiate', {
                            issuer: '2000charge',
                            package_id: self.packageId,
                            data: widget,
                          }).then(({data}) => {
                            console.log('[Twok Listener] Response submit-payment', { widget, data })
                            self.paymentBlocked = true
                            self.hidePrePaymentPopup()
                            window.location.href = data.redirect
                          })
                          break;
                        }
                      }
                    }catch (e){
                      console.log(e)
                    }
                });
            },
            createTwokchargeIframe() {
                let iframe = document.createElement("iframe")
                iframe.setAttribute("frameBorder", "0")
                iframe.setAttribute("id", "twokcharge")
                iframe.setAttribute("allowtransparency", "true")

                let cssAttrs = [
                    "z-index: 9999;",
                    "background: transparent;",
                    "background: rgba(0,0,0,0.005);",
                    "border: 0px none transparent;",
                    "overflow-x: hidden;",
                    "overflow-y: auto;",
                    "margin: 0;",
                    "padding: 0;",
                    "-webkit-tap-highlight-color: transparent;",
                    "-webkit-touch-callout: none;",
                    "position: fixed;",
                    "width: 100%;",
                    "height: 100%;",
                    "top: 0;",
                    "left: 0;"
                ]
                iframe.style.cssText = cssAttrs.join('\n')
                iframe.src = 'https://widget.2000charge.com/v22k/checkout.html' // Live
                //iframe.src = '/checkout.html'; // Test
                jQuery(iframe).hide()
                document.body.appendChild(iframe)

                let self = this
                iframe.onload = function () {
                    self.twokchargeIframeLoaded = true
                }

                return iframe
            },
        },
        mounted() {
            console.log('[Mounted] Pro Upgrade Page')
            if(this.isMobile){
              $('footer').hide();
            }
            this.fetchSettings()

            if (!this.twokchargeIframe) {
                this.twokchargeIframe = this.createTwokchargeIframe()
            }
            this.bindTwokchargeListener()

            if (this.$route.query.paypal_capture) {
              this.paypalCapturing = true;
              let self = this;
              axios.post('/api/subscription/paypal/capture_order',{
                token:this.$route.query.token
              })
                .then((response) => {
                  if (response.data.status === "success") {
                    self.setUserIsPro(true)
                    self.loadCurrentUserInfo(true)
                    self.$emit('bottomMenuState', true)
                    self.setStatus('success')
                    self.hidePaypalWidget();
                    self.hidePrePaymentPopup();
                  }else{
                    self.showErrorNotification('payment_failed_please_contact_admin')
                  }
                  self.paypalCapturing = false;
                })
                .catch((response) => {
                  self.showErrorNotification('payment_failed_please_contact_admin')
                  self.paypalCapturing = false;
                  return false;
                })
            }
        },
        updated() {
          if (!app.isMobile) {
            //this.$parent.$parent.$refs.vueCustomScrollbar.$forceUpdate()
          }
        },
        beforeDestroy() {
            if (this.twokchargeIframe) {
                this.twokchargeIframe.remove()
            }
        }
    }
</script>
